<template>
  <div class="applyForm">
    <van-nav-bar
      title="信息预览"
      left-arrow
      @click-left="backPreview"
      placeholder
      fixed
      safe-area-inset-top
    />
    <div class="form_content">
      <van-form
        @submit="onSubmit"
        ref="formRef"
        label-width="120px"
        scroll-to-error
      >
        <van-cell title="手机号" :value="form.tel" />
        <van-cell title="姓名" :value="form.name" />
        <van-cell title="性别" :value="form.sex" />

        <van-field
          name="uploader"
          label=""
          input-align="right"
          :rules="[{ required: 'onChange', message: '请上传标准证件照' }]"
        >
          <template #label>
            <span
              >上传标准证件照（须上传本人近期正面白底免冠电子证件照片，照片须清晰。）</span
            >
          </template>
          <template #input>
            <van-uploader
              disabled
              v-model="piclink"
              @delete="
                (e, detail) => {
                  delImg(e, detail, 'piclink');
                }
              "
              :after-read="
                (e) => {
                  afterRead(e, 'piclink');
                }
              "
              :max-count="1"
            />
          </template>
        </van-field>
        <van-field
          name="uploader"
          label="身份证正面"
          input-align="right"
          :rules="[{ required: 'onChange', message: '请上传身份证正面' }]"
        >
          <template #input>
            <van-uploader
              disabled
              v-model="cardpositive"
              @delete="
                (e, detail) => {
                  delImg(e, detail, 'cardpositive');
                }
              "
              :after-read="
                (e) => {
                  afterRead(e, 'cardpositive');
                }
              "
              :max-count="1"
            />
          </template>
        </van-field>
        <van-field
          name="uploader"
          label="身份证反面"
          input-align="right"
          :rules="[{ required: 'onChange', message: '请上传身份证反面' }]"
        >
          <template #input>
            <van-uploader
              disabled
              v-model="cardnegative"
              @delete="
                (e, detail) => {
                  delImg(e, 'cardnegative');
                }
              "
              :after-read="
                (e) => {
                  afterRead(e, 'cardnegative');
                }
              "
              :max-count="1"
            />
          </template>
        </van-field>
        <van-cell title="政治面貌" :value="form.political_status" />
        <van-cell title="民族" :value="form.nation" />
        <van-cell title="籍贯" :value="form.native_place" />
        <van-cell title="生源地" :value="form.birthplace" />
        <van-cell title="户籍地" :value="form.domicile" />
        <van-cell title="婚姻状况" :value="form.marital_status" />
        <van-cell title="毕业院校" :value="form.graduated_school" />
        <van-cell
          title="毕业时间"
          :value="$fnc.getTimeFormat(form.graduated_school_time, 'ymd')"
        />
        <van-cell title="学历" :value="form.edu" />
        <van-cell
          title="证件类型"
          :value="
            form.card_type && form.card_type == '0'
              ? '国内身份证'
              : form.card_type && form.card_type == '1'
              ? '香港身份证'
              : '澳门身份证'
          "
        />
        <van-cell
          :title="
            form.card_type && form.card_type == '1'
              ? '香港身份证'
              : form.card_type == '2'
              ? '澳门身份证'
              : '国内身份证号'
          "
          :value="form.id_card"
        />
        <van-cell title="出生日期" :value="form.birth" />
        <van-cell title="年龄" :value="form.age" />
        <van-cell title="家庭地址" :value="address" />
        <van-cell title="详细地址" :value="form.address" />
        <van-field name="uploader" label="上传学历证书" input-align="right">
          <template #input>
            <van-uploader
              disabled
              v-model="diploma"
              @delete="
                (e, detail) => {
                  delImg(e, detail, 'diploma');
                }
              "
              :after-read="
                (e) => {
                  afterReadList(e, 'diploma');
                }
              "
              multiple
            />
          </template>
        </van-field>
        <van-cell title="现有职称" :value="form.current_title" />
        <van-cell
          title="现有从业资格证书、等级"
          :value="form.current_professional_certification"
        />
        <van-cell title="报考城市" :value="form.a_city" />
        <van-cell
          :title="
            '报考岗位' +
            (form.position_applied && form.a_city && appliedShow
              ? `  报考人数： ${applyNumber}`
              : '')
          "
          :value="form.position_applied"
        />
        <van-cell title="对口专业" :value="form.right_major" />
        <van-cell title="专业技能" :value="form.specific_skill" />
        <template v-for="(item, i) in formList">
          <template>
            <van-cell
              :title="item.label + '院校'"
              :value="item.yx"
              :key="i + Math.random() * 100"
            />
            <van-cell
              :title="item.label + '专业'"
              :value="item.zy"
              :key="i + Math.random() * 100"
            />
            <van-cell
              :title="item.label + '学位'"
              :value="item.xw"
              :key="i + Math.random() * 100"
            />
          </template>
        </template>

        <van-cell title="学习和工作经历" :value="form.work_experience" />
        <van-cell title="家庭成员" :value="form.family_member" />

        <van-field name="uploader" label="上传技能证书" input-align="right">
          <template #input>
            <van-uploader
              disabled
              v-model="skills_certificate"
              @delete="
                (e, detail) => {
                  delImg(e, detail, 'skills_certificate');
                }
              "
              :after-read="
                (e) => {
                  afterReadList(e, 'skills_certificate');
                }
              "
              multiple
            />
          </template>
        </van-field>
        <van-field name="uploader" label="上传其他证书" input-align="right">
          <template #input>
            <van-uploader
              disabled
              v-model="other_certificate"
              @delete="
                (e, detail) => {
                  delImg(e, detail, 'other_certificate');
                }
              "
              :after-read="
                (e) => {
                  afterReadList(e, 'other_certificate');
                }
              "
              multiple
            />
          </template>
        </van-field>

        <div style="margin: 16px">
          <van-button round block type="info" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    form: {
      type: Object,
      default: {},
    },
    formList: {
      type: Array,
      default: [],
    },
    address: {
      type: [Number, String],
      default: "",
    },
    applyNumber: {
      type: [Number, String],
      default: 0,
    },
    appliedShow: {
      type: [Number, String],
      default: 0,
    },
    piclink: {
      type: [Object, Array],
      default: [],
    },
    cardpositive: {
      type: [Object, Array],
      default: [],
    },
    cardnegative: {
      type: [Object, Array],
      default: [],
    },
    diploma: {
      type: [Object, Array],
      default: [],
    },
    skills_certificate: {
      type: [Object, Array],
      default: [],
    },
    other_certificate: {
      type: [Object, Array],
      default: [],
    },
  },
  methods: {
    onSubmit() {
      this.$emit("onSubmitDz", 0);
    },
    backPreview() {
      this.$emit("backPreview", 0);
    },
  },
  computed: {},
  created() {},
  components: {},
};
</script>

<style lang="less" scoped>
.applyForm {
  background-color: rgba(204, 204, 204, 0.259);
  height: max-content;
  padding: 12px;
  /* padding-top: 60px; */
}
.applyForm .form_content {
  width: 100%;
  border-radius: 5px;
  overflow: auto;
}
.van-checkbox {
  height: max-content !important;
}
.cns {
  text-align: left;
  padding: 20px 10px;
  .title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    text-align: center;
  }
}
.van-ellipsis {
  white-space: normal !important;
  text-overflow: clip !important;
}
.van-cell__title {
  text-align: left;
}
.van-uploader__preview-delete {
  display: none;
}
.van-uploader__upload {
  display: none;
}
</style>
